module.exports = __webpack_public_path__ + "static/media/draft.9ac1a878.svg";